import { useAtomValue } from "jotai";
import type { MouseEvent } from "react";
import { HorizontalIcon, VerticalIcon } from "@/icons/mind-map-directions";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { ActiveSubMenuState, MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";

interface UseMindMapDirectionButtonProps {
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useMindMapDirectionButton({
    activeSubMenu,
    setActiveSubMenu,
}: UseMindMapDirectionButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("mindMapDirection"));

    const uniqueValues = [...new Set(options.map((option) => option.value))];

    const Icon = uniqueValues[0] === "horizontal" ? HorizontalIcon : VerticalIcon;

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "mindMapDirection" ? null : { name: "mindMapDirection", anchor: button },
        );
    };

    const isActive = activeSubMenu?.name === "mindMapDirection";

    const content = <Icon className={isActive ? styles.svgFillActive : ""} />;

    return {
        content,
        handleClick,
        isActive,
    };
}
